/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Map_No_KeyInputs */

const vi_grower_map_no_key = /** @type {(inputs: Grower_Map_No_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình Google Maps API key`)
};

/**

* @param {Grower_Map_No_KeyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_map_no_key = /** @type {((inputs?: Grower_Map_No_KeyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Map_No_KeyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_map_no_key(inputs)
});